import { type CurrencyCode } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'
import { Price } from '@omnea-app/packages/universal/price/price'

export type Amount = {
  totalAmount: number
  fxRate: number
  currencyCode: CurrencyCode
}

export const mapTermToPrices = (amount: Amount | undefined | null): Price[] | null => {
  if (!amount) return null

  return [
    {
      amount: amount.totalAmount,
      currency: amount.currencyCode,
      fxRate: amount.fxRate,
    },
  ]
}
